import List from './List';

import './styles/style.scss';

export default List;

export { default as ListItem } from './ListItem';



// WEBPACK FOOTER //
// ./src/components/List/index.js